import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'trg-saving-overlay',
  templateUrl: './trg-saving-overlay.component.html',
  styleUrls: ['./trg-saving-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedTrgSavingOverlayComponent {
  @Input() spinner = true;

  constructor() { }
}
